import React, { useState, useMemo, useContext } from 'react';
import styled from 'styled-components';
import { Trans } from 'react-i18next';
import { Body, Flex, ImagesCarousel } from '@ubeya/shared-web/components';
import useArrayManagement from '@ubeya/shared-web/hooks/useArrayManagement';
import { getSource } from '@ubeya/shared-web/utils/files';
import useEmployee from '@ubeya/shared/hooks/employees/useEmployee';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import AddPhoto from './AddPhoto';
import Photo from './Photo';

const SubTitle = styled(Body)`
  margin-top: 6px;
  color: ${({ theme }) => theme.colors.grey4};
`;

const Container = styled(Flex)`
  flex-wrap: wrap;
  margin-top: 17px;
`;

const Photos = ({ employeeId }) => {
  const { data } = useArrayManagement('photos');
  const [isOpenIndex, setIsOpenIndex] = useState();
  const { t } = useContext(ConfigContext);

  const { updateEmployeePhoto } = useEmployee({ employeeId, enabled: false });

  const photos = useMemo(() => data.map((item) => ({ source: getSource(item) })), [data]);

  return (
    <>
      {data.length === 0 && (
        <SubTitle>
          <Trans>addFirstImages</Trans>
        </SubTitle>
      )}

      <Container>
        {data.length > 0 && (
          <>
            {data.map((item, index) => (
              <Photo
                item={item}
                key={index}
                t={t}
                onClick={() => setIsOpenIndex(index)}
                updateEmployeePhoto={updateEmployeePhoto}
              />
            ))}
          </>
        )}

        <AddPhoto />

        <ImagesCarousel views={photos} currentIndex={isOpenIndex} onClose={() => setIsOpenIndex()} />
      </Container>
    </>
  );
};

export default React.memo(Photos);
